import React from "react";

const Error = () => {
  return <div>this is the error component</div>;
};

export default Error;
